import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Broken Arrow, OK?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a Broken Arrow post office or acceptance clerk can take 2–6 months, especially during busy travel seasons. For church groups with mission departures, families with upcoming vacations, and professionals with business travel, that timeline is simply not viable.",
  },
  {
    q: "Our church group is going on a mission trip to Guatemala in 3 weeks. Can you process multiple passports?",
    a: "Yes — group processing for church mission trips is a specialty of ours. We handle Broken Arrow church groups going to Guatemala, Honduras, Costa Rica, Jamaica, and other mission destinations regularly. We coordinate child passport requirements, dual-parent consent forms, and group timelines to make sure every participant is ready for departure. Contact us as soon as your roster is confirmed.",
  },
  {
    q: "Can Broken Arrow families use expedited service for child passports?",
    a: "Absolutely. For children under 16, you need the child's birth certificate, both parents' valid IDs, a DS-11 form, passport photos, and proof of parental relationship. Both parents must appear together or submit a notarized DS-3053 consent form. We provide clear guidance for BA families so the child passport process goes smoothly — especially important for youth group and mission trip travel.",
  },
  {
    q: "Can I renew my Broken Arrow passport without visiting an acceptance facility?",
    a: "Yes. If your most recent passport was issued when you were 16 or older, is undamaged, and was issued within the last 15 years, you can renew by mail — no facility visit needed. Start online, ship your documents overnight from any Broken Arrow UPS or FedEx location, and we handle the rest.",
  },
  {
    q: "Do I need to drive to Oklahoma City for a passport agency appointment?",
    a: "Not with Fast Passport Center. The Oklahoma City Passport Agency at 301 NW 6th Street is about 85 miles from Broken Arrow, and appointments are often unavailable or weeks out. We provide a faster, simpler path through our reserved agency submission slots — you ship documents overnight from Broken Arrow and we handle the submission, no OKC drive required.",
  },
  {
    q: "How much does expedited passport processing cost in Broken Arrow?",
    a: "Our expedited service fees range from $149 for 2-week service to $499 for 24-hour emergency processing. State Department fees are paid separately. We are typically 30–100% lower than FedEx and Staples resellers. As a registered State Department courier (not a middleman), we pass our savings directly to you.",
  },
  {
    q: "Can Coweta and Wagoner residents use Broken Arrow acceptance facilities?",
    a: "Yes. Residents of Coweta, Wagoner, and other Tulsa east metro communities can access the Broken Arrow Post Office or any authorized area facility. Our service covers the entire Tulsa east metro area — start online, ship overnight from any UPS or FedEx location in your community, and we handle the rest.",
  },
  {
    q: "What documents do I need for an expedited passport from Broken Arrow?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required for your specific situation.",
  },
];

export default function BrokenArrowFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Broken Arrow and Tulsa east metro travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}